var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVolumeOff = function SvgVolumeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.291V3.543l-3.651 3.54-1.044-1.077 3.651-3.54c.951-.922 2.544-.248 2.544 1.077v16.748c0 1.349-1.64 2.012-2.578 1.043L7.31 17.6a1.5 1.5 0 0 0-1.079-.457H3a1.5 1.5 0 0 1-1.5-1.5V7.929a1.5 1.5 0 0 1 1.5-1.5h3.26a1.5 1.5 0 0 0 1.045-.423l1.044 1.077a3 3 0 0 1-2.088.846H3v7.714h3.232a3 3 0 0 1 2.157.914L12 20.291ZM15.68 14.721a.962.962 0 0 1 0-1.36L17.04 12l-1.36-1.362a.962.962 0 0 1 1.36-1.36l1.362 1.36 1.36-1.36a.962.962 0 0 1 1.361 1.36L19.763 12l1.36 1.36a.962.962 0 1 1-1.36 1.361l-1.361-1.36-1.361 1.36a.962.962 0 0 1-1.36 0Z"
  })));
};

export default SvgVolumeOff;